export const postVoucher = '/api/voucher/activate';
